import { useMemo, type ReactNode } from 'react'
import { WalletProvider } from '@tronweb3/tronwallet-adapter-react-hooks'
import { TronLinkAdapter } from '@tronweb3/tronwallet-adapter-tronlink'
import { WalletConnectAdapter } from '@tronweb3/tronwallet-adapter-walletconnect'
import { ChainNetwork } from '@tronweb3/tronwallet-abstract-adapter'

interface TronWalletProviderProps {
  children: ReactNode
}

export function TronWalletProvider({ children }: TronWalletProviderProps) {
  const adapters = useMemo(() => {
    const list: (TronLinkAdapter | WalletConnectAdapter)[] = [new TronLinkAdapter()]
    const projectId = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID as string | undefined
    if (projectId) {
      const network = (import.meta.env.VITE_NETWORK || 'testnet') === 'mainnet'
        ? ChainNetwork.Mainnet
        : ChainNetwork.Nile
      list.push(new WalletConnectAdapter({
        network,
        options: {
          relayUrl: 'wss://relay.walletconnect.com',
          projectId,
          metadata: {
            name: 'Parse DeFi',
            description: 'Cross-chain USDC bridge',
            url: window.location.origin,
            icons: [`${window.location.origin}/favicon.ico`],
          },
        },
      }))
    }
    return list
  }, [])

  return (
    <WalletProvider adapters={adapters} autoConnect={true}>
      {children}
    </WalletProvider>
  )
}
